import DateUtils from '@/utils/DateUtils';

export const plannedEventsViewState = {
  namespaced: true,
  state: {
      dateRange:{
        startDate: DateUtils.toLocalISOdate(DateUtils.toStartOfMonth(new Date())),
        endDate: DateUtils.toLocalISOdate(DateUtils.plusMonths(DateUtils.toStartOfMonth(new Date()),3)),
      },
      onlyCurrentUserAssigned:false,
      includeLate:true,


  },
  mutations: {
    setDateRange(state, dateRange) {
      state.dateRange = dateRange;
    },
    setOnlyCurrentUserAssigned(state, onlyCurrentUserAssigned) {
      state.onlyCurrentUserAssigned = onlyCurrentUserAssigned;
    },
    setIncludeLate(state, includeLate) {
      state.includeLate = includeLate;
    },
  },
  getters:{
    dateRange: state =>{
      return state.dateRange;
    },
    onlyCurrentUserAssigned: state =>{
      return state.onlyCurrentUserAssigned;
    },
    includeLate: state =>{
      return state.includeLate;
    },
  },

};
